import "./styles.scss"

import React from "react"
import scrollToElement from "scroll-to-element"
import { motion } from "framer-motion"

import { useLocale } from "context/locale"

import RoundedWrapper from "components/RoundedWrapper"
import Button from "components/Button"

import { textHighlight, fadeAnimation } from "utils"

const Grid = ({ data, positions }) => {
  const { t } = useLocale()

  return (
    <section className="careers-grid">
      <RoundedWrapper className="careers-grid__wrapper">
        <div className="row">
          <div className="col-xl-5 col-md-6">
            <motion.div {...fadeAnimation}>
              <img src={data?.careersHeroThumbnail?.sourceUrl} alt="" />
              <div
                className="careers-grid__thumbnail"
                style={{
                  backgroundImage: `url(${data?.careersHeroThumbnail?.sourceUrl})`,
                }}
              />
            </motion.div>
          </div>
          <div className="col-md-6 offset-xl-1">
            <motion.div {...fadeAnimation}>
              <h2>
                {textHighlight(
                  data?.careersHeroContent.heading.title,
                  data?.careersHeroContent.heading.highlight
                )}
              </h2>
              <div
                dangerouslySetInnerHTML={{
                  __html: data?.careersHeroContent.text,
                }}
              />
              <div className="careers-grid__cta">
                <Button
                  to={t("/company/careers-apply-now/")}
                  className="button--blue"
                >
                  {t("Apply now")}
                </Button>
                {positions?.length > 0 && (
                  <Button
                    onClick={() => scrollToElement("#positions")}
                    className="button--bordered-blue"
                  >
                    {t("See open roles")}
                  </Button>
                )}
              </div>
            </motion.div>
          </div>
        </div>
      </RoundedWrapper>
    </section>
  )
}

export default Grid
